import React, { useState, useEffect } from 'react';

import { Input } from 'antd';
import NumberFormat from 'react-number-format';

const InputNumero = (props)=>{
    
    const {innerRef,onBlur, onChangeValue, onChange, value, ...propsSemOnBlur} = props;
    const initialState = {
        floatValue: 0,
        textValue: ""
    };
    const [componentValue, setComponentValue] = useState(initialState);
    

    useEffect(() => {
        console.log("value changed", value)
        defineValorComponente(value);

    }, [value]);


    const defineValorComponente = (novoValor) => {
        if(!novoValor){
            const retorno = initialState;
            setComponentValue(retorno);
            return retorno;
        }
        if(typeof novoValor == "number"){
            const floatValue = novoValor;
            const textValue = (novoValor + "").replace(".",",");
            const retorno = {floatValue, textValue};
            setComponentValue(retorno);
            return retorno;

        }

        const caracteresPermitidos = /^\d*(,\d*){0,1}$/gm;
        if(!caracteresPermitidos.test(novoValor)){
            return componentValue;
        }  

        const normalizedValue = novoValor.replace(",", ".")

        const parsedValue = parseFloat(normalizedValue);

        if(isNaN(parsedValue)){
            const retorno = Object.assign({}, componentValue, {textValue: novoValor});
            setComponentValue(retorno);
            return retorno;
        }

        const retorno = {textValue: novoValor, floatValue: parsedValue };
        setComponentValue(retorno);
        return retorno;
    }

    const changeHandler = (evt)=> {
        const {target}=evt;
        const {value} = target;

        const retorno = defineValorComponente(value);
        console.log("retorno", retorno);
        onChange && onChange(retorno);
        
        
    }


    const onBlurHandler = (evt)=>{
        console.log("beforeBlur");
        onBlur && onBlur(componentValue)
    }
 
   

    return <Input ref={innerRef} {...propsSemOnBlur} style={{textAlign: 'right'}} onChange={changeHandler} onBlur={onBlurHandler} inputMode={"numeric"} value={componentValue.textValue} ></Input>
}

// const InputNumero = (props)=> {
    
//         const {initialValue, onChangeValue, onChange, value, children} = props;
        
        
//         const [valor, setValor] = useState(initialValue || 0);
//         const [valorFormatado, setValorFormatado] = useState(0);
    
        
        
//         useEffect(() => {
//             formataValor();
//         }, [valor]);
    
//         useEffect(() => {
//             setValor(value);
//             formataValor();
//         },[value])
        
//         let casasDecimais = (initialValue + "").split(".");
//         casasDecimais = casasDecimais[1] ? casasDecimais[1].length: 0;
    
//         const formataValor = () =>{
//             if(isNaN(valor)){
//                 setValorFormatado("0");
//                 return;
//             }
//             const v = valor.toFixed(casasDecimais);
//             const valorFormatado = v.replace(".",",");
//             setValorFormatado(valorFormatado);
//         }
    
//         const onValueChange = (data, a) => {
//             console.log(data);
//             console.log(a)
//             const novoValor = data.target.value;
//             if(isNaN(parseFloat(novoValor))){
//                 setValor(0);
//                 return;
//             }
    
//             const novoValorCents = novoValor.replace(".", "").replace(",", "");
            
//             const novoValorDecimal = (parseInt(novoValorCents) / Math.pow(10, casasDecimais));
//             dispatchOnChange(novoValorDecimal);
//             setValor(novoValorDecimal);
//         }
    
//         const dispatchOnChange = (novoValor) => {
//             if(onChangeValue){
//                 onChangeValue(novoValor)
//             }
//             if(onChange){
//                 onChange(novoValor)
//             }
//         }
    
      
//         return ( 
//         <Input.Group compact={true}>
//             <Input
//                 value={valorFormatado}
//                 type="text"
//                 onChange={onValueChange}
//                 onFocus={evt => evt.target.selectionStart = evt.target.selectionEnd = evt.target.value.length}
//                 onClick={evt => evt.target.selectionStart = evt.target.selectionEnd = evt.target.value.length}
                
//                 style={{textAlign: 'right'}}
//                 inputMode="numeric"
                
//                 ></Input>
            
//         </Input.Group>);
//         // return (<Dinheiro
//         //     value={valor}
//         //     displayType="input" 
//         //     customInput={Input} 
//         //     type="text"
//         //     onChange={onValueChange}
//         //     {...props}
//         // ></Dinheiro>)
    
    
    
    
// }

export {InputNumero};